import * as React from 'react'
import RiderList from '../../../containers/trips/RidersList'
import Cancel from '../../icons/ui/Cancel'
import Search from '../../icons/ui/Search'
import { IOrgObj } from '../../../types'
import { debounce } from 'throttle-debounce'
import Swap from 'src/components/icons/trips/Swap'
import UIMessages from 'src/utils/ui-messages'

interface IRiderSearchProps {
  onClear: () => void
  onInput: (query: string, organizationId: string, isActive?: boolean, isArchived?: boolean) => void
  query: string
  location: any
  currentOrg: IOrgObj
  currentOrgIdRequest: boolean
  currentOrgIdError: string
  activeRidersOny?: boolean
}

interface IRiderSearchState {
  queryString: string
}

class RiderSearch extends React.Component<IRiderSearchProps, IRiderSearchState> {
  public state = {
    queryString: this.props.query
  }

  public autocompleteSearchDebounced = debounce(500, (value: string) => {
    if (!this.props.activeRidersOny) {
      return this.props.onInput(value, this.props.currentOrg.id)
    }
    return this.props.onInput(value, this.props.currentOrg.id, true, false)
  })

  public onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ queryString: e.target.value }, () => {
      this.autocompleteSearchDebounced(this.state.queryString)
    })
  }

  public clearInput = () => {
    this.setState({ queryString: '' })
    this.props.onClear()
  }

  public componentDidMount() {
    this.clearInput()
  }

  public componentWillUnmount() {
    this.clearInput()
  }

  public render() {
    if (!this.props.currentOrg) {
      return <div>{UIMessages.common.loadingData}</div>
    }
    return (
      <article className='RiderSearch'>
        {/* <h2 className='flex RiderHeader font-white bg-blue-grey mt0 mb0  align-center'>
          Arrival{' '}
          <span>
            <Swap />
          </span>
        </h2> */}
        <div className='pb2 pl2 bb-light-grey3 pt2'>
          <p className='mb2 mt0 uppercase font-grey3 h6 letter1'>Search for rider</p>
          <div className='flex items-center col-12 '>
            <div className='col-6 mr1 cursor--text'>
              <input
                // placeholder='Name, ID, DOB, Phone Number'
                placeholder='Name or Phone'
                type='text'
                value={this.state.queryString}
                className='border-none'
                onChange={this.onChange}
              />
            </div>
            {this.props.query && (
              <div className='mr1' onClick={this.clearInput}>
                <Cancel className='icon--small cursor--pointer' />
              </div>
            )}
            {/* <Search className='icon--small' /> */}
          </div>
        </div>
        <RiderList isSearchResult={!!this.props.query} />
      </article>
    )
  }
}

export default RiderSearch



// WEBPACK FOOTER //
// ./src/components/trips/riders/RiderSearch.tsx